const defaultHeaders = {
  'Content-Type': 'application/json',
};

const requestInterceptor = (options) => {  
  const token = localStorage.getItem('authToken');
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  //console.log('Intercepted Request:', options);
  return options;
};


const buildQueryString = (params) => {
  if (!params || typeof params !== 'object') return '';
  
  const query = Object.entries(params)
    .filter(([key, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&');

  return query ? `?${query}` : '';
};


const UseApiService = async (url, options = {}) => {
  const {
    method = 'GET',
    body = null,
    headers = {},
    queryParams = {}
  } = options;
    
  const finalOptions = {
    method,
    headers: {
      ...defaultHeaders,
      ...headers,
    },
    body: body ? JSON.stringify(body) : null,
  };

  const interceptedOptions = requestInterceptor(finalOptions);

  try {
    const response = await fetch(`${url}${buildQueryString(queryParams)}`, interceptedOptions);

    if (!response.ok) {
      if (response.status === 401) {
        console.error('Unauthorized. Redirecting to login...');
        // Aquí se puede redireccionar a la página de login o realizar otras acciones
      }
      const errorData = await response.json();
      throw new Error(errorData.message || 'Network response was not ok');
    }

    const data = await response.json();
    return { data, error: null };
  } catch (error) {
    console.error('Fetch error:', error);
    return { data: null, error };
  }
};

export default UseApiService;

/**
 
===============Para GET =======================

UseApiService(C_APIMODEL_URL, {
  method: 'GET',
  headers: { 'Authorization': 'Bearer your-token',
  'Custom-Header': 'CustomValue',
  'Another-Header': 'AnotherValue' },
  queryParams: { 
    q: textSearch
    , d1: date1
    , d2: date2
  }
})
.then(({ data, error }) => {
  if (error) {
    
    console.log(error.message);
  } else {
    setData(data);
  }
})
.finally(() => {
  setLoading(false);
});


===============Para POST =======================


useApiService('https://api.example.com/submit', {
method: 'POST',
body: { key: 'value' },
headers: {
  'Authorization': 'Bearer your-token',
  'Custom-Header': 'CustomValue',
  'Another-Header': 'AnotherValue'
}
})
.then(({ data, error }) => {
  if (error) {
    setError(error.message);
  } else {
    setPostData(data);
  }
})
.finally(() => {
  setPostLoading(false); // Terminar carga
});

**/